import { createSelector } from 'reselect';
import { ServiceTypeModel } from '@/typings/models/ServiceType';

const selectLocationState = (state: DefaultRootState) => state.location;
const selectUserState = (state: DefaultRootState) => state.user;
const selectLoadingState = (state: DefaultRootState) => state.loading;

export const selectLocation = createSelector(
  [selectLocationState],
  (location) => location
);

export const selectLocations = createSelector(selectLocation, location => location.list || [])

// DEPRECATED: This selector is no longer used and will be removed in a future version
// The inScope functionality has been deprecated from BranchDropdownFilters
export const selectBranches = createSelector(
  [selectUserState],
  (user) => user?.userBranches?.data || []
);

export const selectScopedUserBranches = createSelector(
  [selectUserState],
  (user) => user?.scopedUserBranches?.data || []
);
// DEPRECATED: This selector is no longer used and will be removed in a future version
// The withStaff functionality has been deprecated from BranchDropdownFilters
export const selectScopedWithStaffBranches = createSelector(
  [selectUserState],
  (user) => user?.scopedWithStaffUserBranches?.data || []
);

export const selectManageableBranches = createSelector(
  [selectLocationState],
  (location) => location?.manageableBranches || []
);

export const selectManageableBranchesList = createSelector(
  [selectLocationState],
  (location) => location?.manageableBranchesList
);

export const selectManageableBranchesLoading = createSelector(
  [selectLoadingState],
  (loading) => loading?.effects?.['location/getManageableBranches']
);

export const selectBranchServices = createSelector(
  [selectLocationState],
  (location) => location?.list || []
);

export const selectAgentList = createSelector(
  [selectLocationState],
  (location) => location?.agentList?.data || []
);

export const selectOfferingList = createSelector(
  [selectLocationState],
  (location) => location?.offeringList || []
);

export const selectServiceTypeList = createSelector(
  [selectLocationState],
  (location): ServiceTypeModel[] => location?.serviceTypeList || []
);

export const selectServiceTypeDrawer = createSelector(
  [selectLocationState],
  (location) => location?.serviceTypeDrawer
);

export const selectBranchDrawer = createSelector(
  [selectLocationState],
  (location) => location?.branchDrawer
);
export const selectTimezones = createSelector(
  [selectLocationState],
  (location) => location?.timezones || []
);

export const selectBranchDrawerVisible = createSelector(
  [selectLocationState],
  (location) => location?.branchDrawer?.visible
);


export const selectAllBranchesList = createSelector(
  [selectLocationState],
  (location) => location?.allBranchesList || []
);

export const selectAllBranchesCount = createSelector(
  [selectAllBranchesList],
  (list) => list?.length || 0
);

export const selectBranchDetails = createSelector(
  [selectLocationState],
  (location) => location?.branchDetails || {}
);

export const selectBranchDetail = createSelector(
  [selectBranchDetails, (_, branchId: string) => branchId],
  (branchDetails, branchId) => branchDetails[branchId] || {}
);

export const selectFullBranches = createSelector(
  [selectLocationState],
  (location) => location?.fullBranchesList || []
);
export const selectBranchesDetail = createSelector(
  [selectAllBranchesList, selectBranchDetails, selectFullBranches, (_, branchIds: string[]) => branchIds],
  (allBranches, branchDetails, fullBranches, branchIds) => {
    if (allBranches.length <= 5 && fullBranches.length > 0) return fullBranches;
    return branchIds.map(id => branchDetails[id]).filter(Boolean)
  }
);

export const selectBranchDetailLoading = createSelector(
  [selectLoadingState],
  (loading) => loading?.effects?.['location/getBranch']
);

export const selectFullBranchesLoading = createSelector(
  [selectLoadingState],
  (loading) => loading?.effects?.['location/fetchFullBranchesWithDetails']
);


